import {IAttributes, IRootElementService, IScope} from "angular";

export const ClickCapture = "tfClickCapture";

export function clickCapture() {
    return {
        restrict: "A",
        link($scope: IScope, $elem: IRootElementService, $attr: IAttributes) {
            $elem.on("click", ($event) => {
                $event.preventDefault();
                $event.stopPropagation();
            });
        }
    };
}
